import * as actionTypes from "constants/actionTypes";

export function showOverlayNav() {
  return {
    type: actionTypes.SHOW_OVERLAY_NAV
  };
}

export function hideOverlayNav() {
  return {
    type: actionTypes.HIDE_OVERLAY_NAV
  };
}

export function setOverlayNavMode(navMode) {
  return {
    type: actionTypes.SET_OVERLAY_NAV_MODE,
    payload: { navMode }
  };
}
